import TypographyContainer from "../../Components/Ui-Kits/Typography/Typography"

const Typography = () => {
  return (
    <div className='page-body'>
      <TypographyContainer />
    </div>
  )
}

export default Typography